




































































































































































































































































import { API, Config } from 'client-website-ts-library/services';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PrivacyPolicy extends Vue {
  private business: {
    name: string;
    address: string;
    phoneNumber: string;
    email: string;
  } | null = null;

  mounted() {
    API.Offices.Get(Config.Website.Settings!.WebsiteId).then((office) => {
      this.business = {
        name: office.CompanyName,
        address: `${office.AddressLine1} ${office.AddressLine2}`,
        phoneNumber: office.Phone,
        email: office.Email,
      };
    });
  }
}
